import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalFaqItem, PortalFaqItemWriteInput } from "@colab/shared";

// POST /api/admin/portal-content/faq
//
// Pessimistic. Invalidates portalContent.faqAdmin + portalContent.faqPublic.
export function useCreateFaqItem() {
  const queryClient = useQueryClient();
  return useMutation<
    { id: string; row: PortalFaqItem },
    ApiClientError,
    PortalFaqItemWriteInput
  >({
    mutationFn: (input) =>
      apiFetch<{ id: string; row: PortalFaqItem }>(
        "/admin/portal-content/faq",
        { method: "POST", body: JSON.stringify(input) },
      ),
    onError: (err) => {
      toast.error(err.message ?? "Failed to create FAQ item");
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.faqAdmin(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.faqPublic(),
      });
    },
  });
}
